class MapController {

  // constructor, set_panel
  // show via state change

  constructor() {
    this.$panel = null;
    this.mapElem = null;
    this.googleMap = null;
    this.googleMarkers = [];

    this.markerIcon = null;
    this.markerIconHide = null;
    this.markerIconSelected = null;
    this.activeInfoWindow = null;
    this.settings = {
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      zoomControl: true,
      zoomControlOptions: { position: 8 },
      maxZoom: 14,
      keyboardShortcuts: true,
      clickableIcons: true,
      styles: null,
      zoom: 8,
      center: { lat: 53.20139, lng: 5.80859 }
    }

    window.initMap = this.init.bind(this);

    // Event handeling
    window.addEventListener('listitem_clicked', this.on_listitem_click.bind(this));
    window.addEventListener('filters_changed', this.on_filters_change.bind(this));

  }

  set_panel(elem) {
    this.$panel = elem;
  }

  set_map(elem) {
    this.mapElem = elem;
  }

  set_style() {
    this.settings.styles = window.map_style; // geladen in js/core/map-style.js
  }

  set_maker_icon() {
    var svg = window.btoa(`
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11">
        <circle id="Ellipse_45" data-name="Ellipse 45" cx="5.5" cy="5.5" r="5.5" fill="#b53027"/>
      </svg>
    `);
    this.markerIcon = {
      url: `data:image/svg+xml;base64,${svg}`,
      scaledSize: new google.maps.Size(24, 24),
      anchor: new google.maps.Point(12, 12)
    }

    var svg = window.btoa(`
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11">
        <circle id="Ellipse_45" data-name="Ellipse 45" cx="5.5" cy="5.5" r="5.5" fill="#cccccc"/>
      </svg>
    `);
    this.markerIconHide = {
      url: `data:image/svg+xml;base64,${svg}`,
      scaledSize: new google.maps.Size(24, 24),
      anchor: new google.maps.Point(12, 12)
    }

    var svg = window.btoa(`
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11">
          <circle cx="5.5" cy="5.5" r="5.5" fill="#3e1413"/>
      </svg>
      `);
      this.markerIconSelected = {
        url: `data:image/svg+xml;base64,${svg}`,
        scaledSize: new google.maps.Size(24, 24),
        anchor: new google.maps.Point(12, 12)
      };
  }

  init_googlemap() {
    var self = this;

    var markerElements = self.mapElem.querySelectorAll('.marker'); // van html ..

    this.googleMap = new google.maps.Map(self.mapElem, self.settings);

    var mapBounds = new google.maps.LatLngBounds(); // collection van latlng

    markerElements.forEach(function (markerElem) { // .. naar js
      let info = JSON.parse(markerElem.getAttribute('data-info'));
      let latlng = new google.maps.LatLng(info.lat, info.lng);
      let markerSettings = {
        position: latlng,
        map: self.googleMap,
        label: '',
        zIndex: 1,
        icon: self.markerIcon
      };

      let marker = new google.maps.Marker(markerSettings);
      marker.info = info; // data bij marker opslaan

      // Add to map and coordinates to bounds
      self.googleMarkers.push(marker);
      mapBounds.extend(latlng);

      // Info window
      if (markerElem.innerHTML != '') {
        var infoWindow = new google.maps.InfoWindow({
          content: markerElem.innerHTML
        });

        google.maps.event.addListener(marker, 'click', function (e) {
          if (self.activeInfoWindow != null) self.activeInfoWindow.close();
          self.activeInfoWindow = infoWindow;
          infoWindow.open(self, marker);

          // Reset markers
          self.googleMarkers.forEach(m => {
            m.setIcon(self.markerIcon);
            m.setZIndex(1);
          });
          // Add active marker
          marker.setIcon(self.markerIconSelected);
          marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);

          let event = new CustomEvent('marker_clicked', {
            detail: { post: marker.info.post }
          });
          window.dispatchEvent(event);
        });

        google.maps.event.addListener(infoWindow, 'closeclick', function () {
          let event = new CustomEvent('close_infowindow', {
            detail: { post: marker.info.post }
          });
          window.dispatchEvent(event);
          marker.setIcon(self.markerIcon); 
          marker.setZIndex(1); 
          self.activeInfoWindow = null;
        });

      }
    }); // / foreach

    this.googleMap.setCenter(mapBounds.getCenter());
    this.googleMap.fitBounds(mapBounds);
    this.googleMap.addListener('bounds_changed', () => self.show_visible_markers());
  }

  show_visible_markers() {
    let bounds = this.googleMap.getBounds();
    let posts = [];
    for (var i = 0; i < this.googleMarkers.length; i++) {
      let marker = this.googleMarkers[i];
      if (bounds.contains(marker.getPosition()) === true) {
        posts.push(marker.info.post);
      }
    }
    let event = new CustomEvent('markers_changed', {
      detail: { posts: posts }
    });
    window.dispatchEvent(event);
  }

  on_listitem_click(event) {
    let id = event.detail.post;
    for (var i = 0; i < this.googleMarkers.length; i++) {
      let marker = this.googleMarkers[i];
      if (marker.info.post == id) {
        new google.maps.event.trigger(marker, 'click');
      }
    }
  }

  on_state_change(oldstate, newstate) {
    if (newstate == 2) {
      // no scroll
      var element = document.documentElement;
      element.classList.add("no-scroll");

    } else if(newstate == 1) {
      var element = document.documentElement;
      element.classList.remove("no-scroll");

    }

    if ((newstate == window.werk.ARCHIVE) && (oldstate == window.werk.FEATURED)) {
      this.$panel.addClass('show');

      // Recalc bounds
      var mapBounds = new google.maps.LatLngBounds(); // collection van latlng

      for (var i = 0; i < this.googleMarkers.length; i++) {
        let marker = this.googleMarkers[i];
        mapBounds.extend(marker.getPosition());
      }

      this.googleMap.setCenter(mapBounds.getCenter());
      this.googleMap.fitBounds(mapBounds);



    } else {
      this.$panel.removeClass('show');
    }
  }

  on_filters_change(event) {
    if (event.detail.filters) {
      let hide = [];
      if (event.detail.filters['project-sector'].length > 0) {
        for (var i = 0; i < this.googleMarkers.length; i++) {
          let marker = this.googleMarkers[i];
          let sectorArr = marker.info['project-sector']
          let exists = sectorArr.some(element => jQuery.inArray(element.toString(), event.detail.filters['project-sector']) !== -1);
          if (!exists) hide.push(i);
        }
      }
      if (event.detail.filters['project-expertise'].length > 0) {
        for (var i = 0; i < this.googleMarkers.length; i++) {
          let marker = this.googleMarkers[i];
          let expertiseArr = marker.info['project-expertise']
          let exists = expertiseArr.some(element => jQuery.inArray(element.toString(), event.detail.filters['project-expertise']) !== -1);
          if (!exists) hide.push(i);
        }
      }
      for (var i = 0; i < this.googleMarkers.length; i++) {
        let marker = this.googleMarkers[i];
        if (hide.includes(i)) {
          marker.setIcon(this.markerIconHide);
        } else {
          marker.setIcon(this.markerIcon);
        }
      }
    }
  }

  init() {
    // console.log('Init Maps');
    this.set_style();
    this.set_maker_icon();
    this.init_googlemap();
  }

  err_log(msg) {
    console.log(msg);
    return false;
  }

}